<template>
  <b-form-group
    :label="$t('users.form.name')"
    label-for="name"
  >
    <validation-provider
      #default="{ errors }"
      :name="$t('users.form.name')"
      rules="required"
    >
      <b-form-input
        id="name"
        v-model="dataItem.name"
        :placeholder="$t('users.form.name')"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import {
  BFormGroup, BFormInput,
} from 'bootstrap-vue'
// eslint-disable-next-line no-unused-vars
import { required } from '@validations'

export default {
  name: 'UserName',
  components: {
    BFormGroup,
    BFormInput,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['users/dataItem']
    },
  },
}
</script>

<style scoped>

</style>
